(ns client-portal.client.smart-ordering.sessions.drawer.views
  (:require [client-portal.client.audio.views :as audio]
            [client-portal.client.layout :as l]
            [client-portal.client.smart-ordering.sessions.data :as so.sessions.d]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.sessions.drawer.views :as vi.drawer]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as time]
            [shared.core.util :as util]))

(defn ->detail [selected]
  (if selected
    @(re/subscribe [:smart-ordering/conversation- selected])
    :loading))

(defn ms->display [ms]
  (some-> ms (/ 1000) (js/Math.round) (time/seconds->format)))

(defn display-value [tags tag-name]
  (let [v (so.sessions.d/tag-value tags tag-name)]
    (if (util/not-blank-string? v)
      (tag/tag->display-name {:source-name tag-name
                              :value v})
      "-")))

(defn header []
  (let [copied-link?* (re/ratom false)
        concept-id- (re/subscribe [:concepts/current-concept-id-])
        selected- (re/subscribe [:smart-ordering/selected-session-])]
    (fn []
      [:div {:style {:background-color (style/alc-color "Background/secondary")
                     :flex "0 0 auto"
                     :display :flex
                     :gap 8
                     :padding "12px 16px"
                     :position :sticky
                     :top 0
                     :min-height 58
                     :box-sizing :border-box
                     :z-index (inc (style/z :medium))}}
       [:span {:style {:color (style/alc-color "Text/primary_header")
                       :display :flex
                       :align-items :center
                       :font-size 20
                       :font-weight 400
                       :line-height 1.4}}
        "Session Detail"]
       [c/spacer]
       ^{:key (str "share-" @copied-link?*)}
       [alc/tooltip
        {:tooltip-content (if @copied-link?* "Copied" "Copy Session Link")
         :target-content [alc/up-ghost-button {:icon-type (if @copied-link?* :CheckCircleIcon :CopyIcon)
                                               :on-click #(do
                                                            (re/dispatch [:core/copy-to-clipboard
                                                                          (so.sessions.d/sharable-session-url @concept-id- @selected-)
                                                                          {:notify? false}])
                                                            (reset! copied-link?* true)
                                                            (util/wait 1500 (fn [] (reset! copied-link?* false))))}]}]
       [alc/up-button {:icon-type :CrossIcon
                       :rounded? true
                       :on-click #(re/dispatch [:smart-ordering/toggle-session-panel {:open? false}])}]])))

(defn metric-card [{:keys [label value color]}]
  [:div {:style {:background-color (style/alc-color "Background/primary")
                 :border-radius 8
                 :display :flex
                 :flex-direction :column
                 :align-items :center
                 :flex 1
                 :padding 10
                 :gap 2
                 :height 66}}
   [:span {:style {:color (style/alc-color "Text/secondary")
                   :font-size 12
                   :line-height 1.33}}
    label]
   [:span {:style (cond-> {:font-size 18
                           :line-height 1.56
                           :color color}
                          (nil? value)
                          (assoc :opacity 0.6))}
    (or value "-")]])

(defn overview []
  (let [copied-convo-id?* (re/ratom false)
        selected- (re/subscribe [:smart-ordering/selected-session-])
        sessions- (re/subscribe [:smart-ordering/sessions-flattened-])
        next-page-loading?- (re/subscribe [:smart-ordering/sessions-next-page-loading?-])
        admin?- (re/subscribe [:account/admin-role?-])]
    (fn []
      (let [selected @selected-
            idx (:convo-idx selected)
            detail (->detail selected)
            tags (:tags (util/when-not-loading detail))
            loading? (util/loading? detail)
            nav-placeholder [:div {:style {:flex "0 0 36px"}}]]
        [:div {:style {:background-color (style/alc-color "Background/secondary")
                       :display :flex
                       :flex-direction :column
                       :align-items :center
                       :gap 4
                       :padding "12px 0 0"}}
         (when @admin?-
           ^{:key (str "convo-id-" @copied-convo-id?*)}
           [alc/tooltip
            {:tooltip-content (if @copied-convo-id?* "Copied" "Copy Conversation ID")
             :target-content [c/interactive
                              :div {:on-click #(do
                                                 (re/dispatch [:core/copy-to-clipboard
                                                               (:conversation-id selected)
                                                               {:notify? false}])
                                                 (reset! copied-convo-id?* true)
                                                 (util/wait 1500 (fn [] (reset! copied-convo-id?* false))))}
                              [:div {:style (cond-> {:color (style/alc-color "Text/secondary")
                                                     :display :flex
                                                     :align-items :center
                                                     :justify-content :center
                                                     :gap 9}
                                                    (not @copied-convo-id?*)
                                                    (assoc :cursor :pointer))}
                               [:span {:style {:color :inherit
                                               :font-size 14
                                               :line-height 1.43}}
                                (:conversation-id selected)]
                               [c/material-icon {:icon-type (if @copied-convo-id?* :check-circle :content-copy)
                                                 :style {:color (style/alc-color "Icons/secondary")
                                                         :font-size 14}}]]]}])
         [:div {:style {:display :flex
                        :align-items :center
                        :justify-content :space-between
                        :padding "0 16px"
                        :width "100%"}}
          (if (and idx (pos? idx))
            [alc/up-ghost-button {:icon-type :ArrowLeftIcon
                                  :disabled @next-page-loading?-
                                  :on-click #(re/dispatch [:smart-ordering/move-session :prev])}]
            nav-placeholder)
          [:span {:style {:color (style/alc-color "Text/primary_header")
                          :font-size 20
                          :line-height 1.4}}
           (or (:conversation-ts selected)
               (some-> (util/when-not-loading detail)
                       :conversation-ts
                       (time/reformat-date-str "M/d/yy h:mm A")))]
          (if (and idx (or (< idx (dec (count @sessions-))) @next-page-loading?-))
            [alc/up-ghost-button {:icon-type :ArrowRightIcon
                                  :disabled @next-page-loading?-
                                  :on-click #(re/dispatch [:smart-ordering/move-session :next])}]
            nav-placeholder)]
         [:div {:style {:display :flex
                        :gap 8
                        :padding "12px 16px"
                        :width "100%"}}
          (if loading?
            (into [:<>]
                  (repeat 3 [c/loader-rectangle {:height 66
                                                 :style {:border-radius 8
                                                         :flex 1}}]))
            [:<>
             [metric-card {:label "Duration"
                           :value (some-> (util/when-not-loading detail) :duration (js/Math.round) (time/seconds->format))
                           :color (style/alc-color "Chart/tech_blue")}]
             [metric-card {:label "Order Total"
                           :value (so.sessions.d/order-price tags "internal/validated-total")
                           :color (style/alc-color "Chart/orchid")}]
             [metric-card {:label "Items"
                           :value (some-> (so.sessions.d/final-items tags) (not-empty) (so.sessions.d/item-count) (str))
                           :color (style/alc-color "Chart/turquoise")}]])]]))))

(defn summary-section []
  (let [location-id->label @(re/subscribe [:locations/location-id->label-by-current-concept-id-])
        {:keys [tags location-id]} (util/when-not-loading (->detail @(re/subscribe [:smart-ordering/selected-session-])))
        value-of #(display-value tags %)]
    [vi.drawer/section-container {:default-expanded? true
                                  :title "Summary"}
     [vi.drawer/inner-section {:style {:display :flex
                                       :align-items :center
                                       :justify-content :center
                                       :gap 10}}
      [:span (or (some->> location-id (util/parse-int) (get (util/when-not-loading location-id->label)))
                 "N/A")]
      [c/material-icon {:icon-type :arrow-forward
                        :style {:color (style/alc-color "Icons/secondary")
                                :font-size 14}}]
      [:span (value-of "outcome")]]
     [vi.drawer/inner-section {:style {:display :grid
                                       :grid-template-columns "1fr 1fr 1fr"
                                       :gap 12}}
      (for [[label tag-name] [["Occasion" "occasion"]
                              ["Exit Type" "exit-type"]
                              ["End Reason" "end-reason"]
                              ["Language" "language"]
                              ["Pace" "pace"]
                              ["Start" "start"]]]
        ^{:key tag-name}
        [vi.drawer/title-values-entry {:title label
                                       :values [(value-of tag-name)]}])]]))

(defn order-section []
  (let [{:keys [tags]} (util/when-not-loading (->detail @(re/subscribe [:smart-ordering/selected-session-])))
        items (so.sessions.d/final-items tags)
        totals (->> [["Subtotal" "internal/validated-subtotal"]
                     ["Total" "internal/validated-total"]]
                    (keep (fn [[label tag-name]]
                            (some->> (so.sessions.d/order-price tags tag-name) (vector label)))))]
    (when (or (not-empty items) (not-empty totals))
      [vi.drawer/section-container {:default-expanded? true
                                    :title "Order"}
       (when (not-empty items)
         [vi.drawer/inner-section {:title "Items"}
          (into [:div {:style {:display :flex
                               :flex-direction :column}}]
                (map (fn [{:keys [name price quantity]}]
                       [vi.drawer/sub-call-summary-row {:display-value (cond->> name
                                                                         (> quantity 1) (str quantity " × "))
                                                        :call-time price
                                                        :include-outcome-spacing? false}])
                     items))])
       (when (not-empty totals)
         [vi.drawer/inner-section {:style {:display :flex
                                           :gap 10}}
          (for [[label price] totals]
            ^{:key label}
            [:div {:style {:flex 1}}
             [vi.drawer/title-values-entry {:title label
                                            :values [price]}]])])])))

(defn upsell-section []
  (let [{:keys [tags utterance-tags]} (util/when-not-loading (->detail @(re/subscribe [:smart-ordering/selected-session-])))
        moments (->> utterance-tags
                     (filter #(contains? #{"crew-upsell" "upsell-response"} (:name %)))
                     (sort-by :start))]
    (when (or (= "true" (so.sessions.d/tag-value tags "internal/upsell-offered")) (not-empty moments))
      [vi.drawer/section-container {:default-expanded? false
                                    :title "Upsell"}
       [vi.drawer/inner-section {:style {:display :grid
                                         :grid-template-columns "1fr 1fr 1fr"
                                         :gap 12}}
        (for [[label tag-name] [["Size" "size-upsell"]
                                ["Add-On" "add-on-upsell"]
                                ["Item" "item-upsell"]]]
          ^{:key tag-name}
          [vi.drawer/title-values-entry {:title label
                                         :values [(display-value tags tag-name)]}])
        [vi.drawer/title-values-entry {:title "Accepted"
                                       :values [(display-value tags "internal/upsell-accepted")]}]
        [vi.drawer/title-values-entry {:title "Upsell Value"
                                       :values [(or (so.sessions.d/upsell-value tags) "-")]}]]
       (when (not-empty moments)
         [vi.drawer/inner-section {}
          (into [:div {:style {:display :flex
                               :flex-direction :column}}]
                (map (fn [{:keys [description start]}]
                       [vi.drawer/sub-call-summary-row {:display-value description
                                                        :call-time (ms->display start)
                                                        :start-ms start
                                                        :include-outcome-spacing? false}])
                     moments))])])))

(defn phases-section []
  (let [{:keys [utterance-tags duration]} (util/when-not-loading (->detail @(re/subscribe [:smart-ordering/selected-session-])))
        phases (->> (so.sessions.d/tags-by-name utterance-tags "phase")
                    (sort-by :start)
                    (vec))]
    (when (not-empty phases)
      [vi.drawer/section-container {:default-expanded? false
                                    :title "Phases"}
       [vi.drawer/inner-section {}
        (into [:div {:style {:display :flex
                             :flex-direction :column}}]
              (map-indexed (fn [idx {:keys [value start]}]
                             (let [end (or (:start (get phases (inc idx)))
                                           (some-> duration (* 1000)))]
                               [vi.drawer/sub-call-summary-row {:value value
                                                                :call-time (str (ms->display start) " - " (or (ms->display end) "N/A"))
                                                                :start-ms start
                                                                :include-outcome-spacing? false}]))
                           phases))]])))

(defn phase-blocks
  "Phase spans over the transcript for `vi.drawer/utterances-transcript-list`: each
   phase runs from its utterance to the one before the next phase starts."
  [utterances phases]
  (let [start->idx (into {} (map (juxt :start :idx)) utterances)
        last-idx (dec (count utterances))]
    (->> phases
         (map-indexed (fn [i {:keys [value start]}]
                        (when-let [start-idx (start->idx start)]
                          (let [label (tag/tag->display-name {:name "phase"
                                                              :source-name "phase"
                                                              :value value})]
                            {:start-label label
                             :end-label (str label " - End")
                             :start-idx start-idx
                             :end-idx (or (some-> (get phases (inc i)) :start start->idx dec (max start-idx))
                                          last-idx)
                             :icon-type :check-circle}))))
         (filterv identity))))

(defn transcript-section []
  (let [selected @(re/subscribe [:smart-ordering/selected-session-])
        {:keys [utterances utterance-tags audio-url]} (util/when-not-loading (->detail selected))
        audio? (not-empty audio-url)
        search-val @(re/subscribe [:form/val- so.sessions.d/search-transcript-path :value])
        start->tags (->> utterance-tags
                         (remove #(= (:name %) "phase"))
                         (group-by :start))
        utterances (vec (map-indexed (fn [idx {:keys [start] :as u}]
                                       (assoc u :idx idx
                                                :tags (get start->tags start)))
                                     utterances))
        phases (->> (so.sessions.d/tags-by-name utterance-tags "phase")
                    (sort-by :start)
                    (vec))]
    [vi.drawer/section-container {:default-expanded? true
                                  :title "Transcript"}
     [:div {:style {:background-color (style/alc-color "Background/secondary")
                    :border-bottom (str "1px solid " (style/alc-color "Border/divider"))
                    :display :flex
                    :flex-direction :column
                    :gap 13
                    :padding 16
                    :position :sticky
                    :top 58
                    :z-index (style/z :medium)}}
      (when audio?
        [audio/simple-audio-player {:audio-id :session-audio-player
                                    :url audio-url
                                    :extra-on-time-update #(re/dispatch [:sessions/set-audio-current-time (* % 1000)])
                                    :show-playback-speed? true
                                    :space-keybinding? false
                                    :playback-speed-path (conj so.sessions.d/root-path :conversation-audio)
                                    :style {:padding 0}}])
      [alc/up-input {:placeholder "Search Transcript"
                     :form-path so.sessions.d/search-transcript-path
                     :form-name :value}]]
     (if (empty? utterances)
       [vi.drawer/no-message-block {:message "No transcript for this session"}]
       [vi.drawer/utterances-transcript-list {:utterances utterances
                                              :convo-start (:start selected)
                                              :audio? audio?
                                              :search-val search-val
                                              :highlight-blocks (phase-blocks utterances phases)}])]))

(defmethod l/panel-right-view
  so.sessions.d/panel-key [_]
  (let [selected @(re/subscribe [:smart-ordering/selected-session-])
        detail (->detail selected)
        loading? (util/loading? detail)]
    [:div {:id :session-drawer-scroll-container
           :style (cond-> {:overflow :auto}
                          loading?
                          (assoc :display :flex
                                 :flex-direction :column))}
     [header]
     [overview]
     (cond
       loading?
       [alc/up-loader-with-label {:label "Loading Session..."
                                  :style {:flex 1
                                          :height :auto
                                          :min-height :auto}}]

       (empty? detail)
       [vi.drawer/no-message-block {:message (str "No Session Found For \"" (:conversation-id selected) "\"")}]

       :else
       [:div
        [summary-section]
        [order-section]
        [upsell-section]
        [phases-section]
        [transcript-section]])]))
